const extractTitlesFromTagLine = (tagline) => {
  const titles = tagline ? tagline.split('|') : [];
  const trimmedTitles = titles.map((text) => text.trim());
  return trimmedTitles;
};

export default extractTitlesFromTagLine;
